/**
 * What a rail row shows about a section (crossmarc/steward-app#1886). Three states, drawn as
 * a hollow circle, a bronze ring and a filled bronze circle, and named per form because the
 * two forms mean different things by them:
 *
 *  - the onboarding form: like the intake, `started` is opened and `done` is "answered" (the
 *    section holds at least one answer; completeness is Review's job);
 *  - the intake: `started` is "viewed" (the client opened it) and `done` is "answered" (it
 *    holds at least one answer). Nothing in the intake is required, so neither is "complete".
 */
export type SectionMark = 'notStarted' | 'started' | 'done';

/** The words a screen reader gets for each mark. The visible circle carries none of them. */
export interface MarkWords {
  notStarted: string;
  started: string;
  done: string;
}

export const ONBOARDING_MARK_WORDS: MarkWords = { notStarted: 'not started', started: 'started', done: 'answered' };
export const INTAKE_MARK_WORDS: MarkWords = { notStarted: 'not yet viewed', started: 'viewed', done: 'answered' };

export interface RailSection {
  key: string;
  label: string;
  mark: SectionMark;
  /** The Review row: not numbered, dashed circle with an arrow, set apart below a hairline. */
  review?: boolean;
}
